import { render, staticRenderFns } from "./jmOrderForm2022.vue?vue&type=template&id=451f9a89&scoped=true&"
import script from "./jmOrderForm2022.vue?vue&type=script&lang=js&"
export * from "./jmOrderForm2022.vue?vue&type=script&lang=js&"
import style0 from "./jmOrderForm2022.vue?vue&type=style&index=0&id=451f9a89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f9a89",
  null
  
)

export default component.exports